import { render, staticRenderFns } from "./Financeiro.vue?vue&type=template&id=54d50886"
import script from "./Financeiro.vue?vue&type=script&lang=js"
export * from "./Financeiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports